import {Background} from '~/common/fabric/CreateDesign/components/Background/Background';
import {BackgroundEditor} from '~/common/fabric/CreateDesign/components/Background/BackgroundEditor';
import {Container} from '~/common/fabric/CreateDesign/components/Container/Container';

export const BackgroundContainer = () => (
  <Container>
    <Background />
    <BackgroundEditor />
  </Container>
);
